export default __webpack_public_path__ + "static/media/X_Xaxim.9c79465c.mp3";